import axios from 'axios';
import pfn from './IntrodutionFns.js'
import { toolUtils } from '../../../../utils/toolUtils.js'

export default {
  updateIntroduction: async function (payload, props, setFuncMap) {
    try {
      setFuncMap.setIsContentLoading(true)
      if (payload.id) {
        await this.updateIntroductionByIdAction(payload, props.conferenceUid)
      }
      else {
        await this.updateIntroductionAction(payload, props.conferenceUid)
      }
      let res = await pfn.getIntroductionsAction(props.conferenceUid)
      setFuncMap.setIsContentLoading(false)
      setFuncMap.setLangIntroduction(res.data.find(item => { return item.lang === payload.lang }))
    } catch (error) {
    }
  },
  updateIntroductionAction: (payload, conferenceUid) => {
    return axios({
      method: 'POST',
      url: `/conference/${conferenceUid}/introduction`,
      headers: {
        "role": "topUser"
      },
      data: payload
    })
  },
  updateIntroductionByIdAction: (payload, conferenceUid) => {
    return axios({
      method: 'POST',
      url: `/conference/${conferenceUid}/introduction/${payload.id}`,
      headers: {
        "role": "topUser"
      },
      data: payload
    })
  },
  getIntroduction: async function (props, setFuncMap) {
    try {
      setFuncMap.setIsContentLoading(true)
      const res = await this.getIntroductionsAction(props.conferenceUid)
      let result = {}
      res.data.forEach(item => {
        result[item.lang] = item
      })
      setFuncMap.setIntroductionMap(result)
      setFuncMap.setIsContentLoading(false)
    } catch (error) {
    }
  },
  getIntroductionByIdAction: (conferenceUid) => {
    return axios({
      method: 'GET',
      url: `/conference/${conferenceUid}/introduction`,
      headers: {
        "role": "topUser"
      }
    })
  },
};
